import { render, staticRenderFns } from "./HJ212Records.vue?vue&type=template&id=41b50d3c&scoped=true&"
import script from "./HJ212Records.vue?vue&type=script&lang=js&"
export * from "./HJ212Records.vue?vue&type=script&lang=js&"
import style0 from "./HJ212Records.vue?vue&type=style&index=0&id=41b50d3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b50d3c",
  null
  
)

export default component.exports